import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { EntityApiKeysRepository } from "@entity-api-keys/data/repositories/entity-api-keys.repository";
import { CreateEntityApiKey } from "@entity-api-keys/domain/models/create-entity-api-key.model";
import { CreatedEntityApiKey } from "@entity-api-keys/domain/models/entity-api-key.model";
import { getEntityApiKeyToastErrorMessage } from "@entity-api-keys/domain/utils/entity-api-key-toast-error-message";
import { inject, injectable } from "inversify";

@injectable()
export class CreateEntityApiKeyUseCase {
    constructor(
        @inject(EntityApiKeysRepository)
        private readonly repository: EntityApiKeysRepository,
    ) {}

    async execute(
        model: CreateEntityApiKey,
    ): Promise<Nullable<CreatedEntityApiKey>> {
        const result = await this.repository.create(model);

        if (result.isLeft()) {
            ToastManagerStore.error(
                getEntityApiKeyToastErrorMessage(result.getLeftOrThrow()),
            );
        }

        return result.fold(
            () => null,
            (created) => created,
        );
    }
}
